import { BehaviorSubject, Observable } from "rxjs"
import { DtoError } from "../model/dto-error.model"
import { Media } from "../model/media.model"
import { DelarDto, DelarDtoError } from "../service/dto/delar.dto"
import { Delar } from "../service/response/delar.response"
import { District } from "../service/response/district.response"
import { State } from "../service/response/state.response"
import { SubDistrict } from "../service/response/sub-district.response"
import { Village } from "../service/response/village.response"

let _delarDto: DelarDto = {} as DelarDto

let _delarDtoError: DelarDtoError = {
    phone: new DtoError("", false),
    name: new DtoError("", false),
    language: new DtoError("", false),
    intro: new DtoError("", false),
    alternatePhone: new DtoError("", false),
    shopName: new DtoError("", false),
    shopAddress: new DtoError("", false),
    shopPhotos: new DtoError("Upload atleast 1 image", true),
    pesticideLiscence: new DtoError("", false),
    fertilizerLiscence: new DtoError("", false),
    seedLiscence: new DtoError("", false),
    status: new DtoError("", false),
    location: new DtoError("", false),
    pinCodeError: new DtoError("", false),
    state: new DtoError("This is a required field", true),
    district: new DtoError("This is a required field", true),
    city: new DtoError("This is a required field", true),
    village: new DtoError("This is a required field", true),
    pesticidePhoto: new DtoError("Upload atleast 1 image", true),
    fertilizerPhoto: new DtoError("Upload atleast 1 image", true),
    seedPhoto: new DtoError("Upload atleast 1 image", true),
} as DelarDtoError

let _delarDtoSubject = new BehaviorSubject<DelarDto | null>(null)
let _delarDtoErrorSubject = new BehaviorSubject<DelarDtoError | null>(_delarDtoError)

let _delarDetail: BehaviorSubject<Delar | null> = new BehaviorSubject<Delar | null>(null)

let _delarInfo: Delar
let _delarInfoSubject = new BehaviorSubject<Delar | null>(null)

const getMediaObjectFromArray = (newMedias: Array<Media>): any => {
    const photos = new Map()
    newMedias.forEach((media: Media) => {
        photos.set(media.fid, media)
    })

    return Object.fromEntries(photos)
}

const checkPhoneError = () => {
    if (!_delarDto || _delarDto.phone?.length > 10 || _delarDto.phone?.length < 10) {
        _delarDtoError.phone.error = true
        _delarDtoError.phone.msg = "Phone should contain 10 digits"
    } else {
        _delarDtoError.phone.error = false
        _delarDtoError.phone.msg = ""
    }
    _delarDtoErrorSubject.next({ ..._delarDtoError })
}

const checkNameError = () => {
    if (!_delarDto || _delarDto?.name?.length < 3 || _delarDto?.name?.length > 25) {
        _delarDtoError.name.error = true
        _delarDtoError.name.msg = "Name should have minimum 4 characters"
    } else {
        _delarDtoError.name.error = false
        _delarDtoError.name.msg = ""
    }
    _delarDtoErrorSubject.next({ ..._delarDtoError })
}

const checkIntroError = () => {
    if (!_delarDto || _delarDto?.intro?.length < 4 || _delarDto?.intro?.length > 80) {
        _delarDtoError.intro.error = true
        _delarDtoError.intro.msg = "Introduction should be within 400 charcaters"
    } else {
        _delarDtoError.intro.error = false
        _delarDtoError.intro.msg = ""
    }
    _delarDtoErrorSubject.next({ ..._delarDtoError })
}

const checkAlternatePhoneError = () => {
    if (!_delarDto || _delarDto?.alternatePhone?.length > 10 || _delarDto?.alternatePhone?.length < 10) {
        _delarDtoError.alternatePhone.error = true
        _delarDtoError.alternatePhone.msg = "Phone should contain 10 digits"
    } else {
        _delarDtoError.alternatePhone.error = false
        _delarDtoError.alternatePhone.msg = ""
    }
    _delarDtoErrorSubject.next({ ..._delarDtoError })
}

const checkShopNameError = () => {
    if (!_delarDto || _delarDto?.shopName?.newName.length < 4) {
        _delarDtoError.shopName.error = true
        _delarDtoError.shopName.msg = "Shop Name should have minimum 4 charcters"
    } else {
        _delarDtoError.shopName.error = false
        _delarDtoError.shopName.msg = ""
    }
    _delarDtoErrorSubject.next({ ..._delarDtoError })
}

const checkShopAddressError = () => {
    if (!_delarDto || _delarDto?.shopAddress.streetLine?.length < 4) {
        _delarDtoError.shopAddress.error = true
        _delarDtoError.shopAddress.msg = "Street Address should have minimum 4 charcters"
    } else {
        _delarDtoError.shopAddress.error = false
        _delarDtoError.shopAddress.msg = ""
    }
    _delarDtoErrorSubject.next({ ..._delarDtoError })
}

const checkShopPhotosError = () => {
    if (!_delarDto || _delarDto?.shopPhotos?.size > 0) {
        _delarDtoError.shopPhotos.error = false
        _delarDtoError.shopPhotos.msg = ""
    } else {
        _delarDtoError.shopPhotos.error = true
        _delarDtoError.shopPhotos.msg = "Upload atleast 1 image"
    }

}

const checkStateError = () => {
    if (_delarDto?.shopAddress?.geoAddress?.state)
        _delarDtoError.state.error = false
    else
        _delarDtoError.state.error = true
    _delarDtoErrorSubject.next({ ..._delarDtoError })
}

const checkDistrictError = () => {
    if (_delarDto?.shopAddress?.geoAddress?.district)
        _delarDtoError.district.error = false
    else
        _delarDtoError.district.error = true
    _delarDtoErrorSubject.next({ ..._delarDtoError })
}

const checkSubDisctrictError = () => {
    if (_delarDto?.shopAddress?.geoAddress?.subDistrict)
        _delarDtoError.city.error = false
    else
        _delarDtoError.city.error = true
    _delarDtoErrorSubject.next({ ..._delarDtoError })
}

const checkVillageError = () => {
    if (_delarDto?.shopAddress?.geoAddress?.village)
        _delarDtoError.village.error = false
    else
        _delarDtoError.village.error = true
    _delarDtoErrorSubject.next({ ..._delarDtoError })
}

const checkPincodeError = () => {
    if (!_delarDto || _delarDto?.shopAddress?.pinCode != 0 && _delarDto?.shopAddress?.pinCode.toString().length != 6) {
        _delarDtoError.pinCodeError.error = true
        _delarDtoError.pinCodeError.msg = "Pin code should have 6 charcters"
    } else {
        _delarDtoError.pinCodeError.error = false
        _delarDtoError.pinCodeError.msg = ""
    }
    _delarDtoErrorSubject.next({ ..._delarDtoError })
}

export const DelarStore = {
    getDelarDto: (): DelarDto | null => {
        return { ..._delarDto }
    },
    getDelarDtoError: (): DelarDtoError | null => {
        return { ..._delarDtoError }
    },
    setDelarDto: (newDelarDto: DelarDto) => {
        _delarDto = newDelarDto
        _delarDtoSubject.next({ ..._delarDto })
    },
    updatePhone: (phone: string) => {
        _delarDto.phone = phone
        _delarDtoSubject.next({ ..._delarDto })
        checkPhoneError()
    },
    updateName: (name: string) => {
        _delarDto.name = name
        _delarDtoSubject.next({ ..._delarDto })
        checkNameError()
    },
    updateLanguage: (language: string) => {
        _delarDto.language = language
        _delarDtoSubject.next({ ..._delarDto })
    },
    updateIntro: (intro: string) => {
        _delarDto.intro = intro
        _delarDtoSubject.next({ ..._delarDto })
        checkIntroError()
    },
    updateAlternatePhone: (alternatePhone: string) => {
        _delarDto.alternatePhone = alternatePhone
        _delarDtoSubject.next({ ..._delarDto })
        checkAlternatePhoneError()
    },
    updateShopName: (shopName: string) => {
        _delarDto.shopName.newName = shopName
        _delarDtoSubject.next({ ..._delarDto })
        checkShopNameError()
    },
    updateStreetAddress: (streetLine: string) => {
        _delarDto.shopAddress.streetLine = streetLine
        _delarDtoSubject.next({ ..._delarDto })
        checkShopAddressError()
    },
    updateLandmark: (landMark: string) => {
        _delarDto.shopAddress.landMark = landMark
        _delarDtoSubject.next({ ..._delarDto })
    },
    updatePinCode: (pinCode: number) => {
        _delarDto.shopAddress.pinCode = Number(pinCode)
        _delarDtoSubject.next({ ..._delarDto })
        checkPincodeError()
    },
    updatePesticideLicenseNumber: (number: string) => {
        _delarDto.pesticideLiscence.licence.number = number
        if (number?.length !== 10) {
            _delarDtoError.pesticideLiscence.error = true
            _delarDtoError.pesticideLiscence.msg = "License Number should contain 10 digits"
        }
        else {
            _delarDtoError.pesticideLiscence.error = false
            _delarDtoError.pesticideLiscence.msg = ""
        }
        _delarDtoErrorSubject.next({ ..._delarDtoError })
        _delarDtoSubject.next({ ..._delarDto })
    },
    updateFertilizerLicenseNumber: (number: string) => {
        _delarDto.fertilizerLiscence.licence.number = number
        if (number?.length !== 10) {
            _delarDtoError.fertilizerLiscence.error = true
            _delarDtoError.fertilizerLiscence.msg = "License Number should contain 10 digits"
        }
        else {
            _delarDtoError.fertilizerLiscence.error = false
            _delarDtoError.fertilizerLiscence.msg = ""
        }
        _delarDtoErrorSubject.next({ ..._delarDtoError })
        _delarDtoSubject.next({ ..._delarDto })
    },
    updateSeedLicenseNumber: (number: string) => {
        _delarDto.seedLiscence.licence.number = number
        if (number?.length !== 10) {
            _delarDtoError.seedLiscence.error = true
            _delarDtoError.seedLiscence.msg = "License Number should contain 10 digits"
        }
        else {
            _delarDtoError.seedLiscence.error = false
            _delarDtoError.seedLiscence.msg = ""
        }
        _delarDtoErrorSubject.next({ ..._delarDtoError })
        _delarDtoSubject.next({ ..._delarDto })
    },
    updateStatus: (status: number, msg: string) => {
        _delarDto.status.value = status
        _delarDto.status.msg = msg
        _delarDtoSubject.next({ ..._delarDto })
    },
    updateState: (state: State) => {
        _delarDto.shopAddress.geoAddress.state = state
        _delarDtoSubject.next({ ..._delarDto })
        checkStateError()
    },
    updateDistrict: (district: District) => {
        _delarDto.shopAddress.geoAddress.district = district
        _delarDtoSubject.next({ ..._delarDto })
       checkDistrictError()
    },
    updateSubDistrict: (subDistrict: SubDistrict) => {
        _delarDto.shopAddress.geoAddress.subDistrict = subDistrict
        _delarDtoSubject.next({ ..._delarDto })
        checkSubDisctrictError()
    },
    updateVillage: (village: Village) => {
        _delarDto.shopAddress.geoAddress.village = village
        _delarDtoSubject.next({ ..._delarDto })
        checkVillageError()
    },
    updateShopImages: (newImages: Array<Media>) => {

        _delarDto.shopPhotos = getMediaObjectFromArray(newImages)

        _delarDtoSubject.next({ ..._delarDto })
        checkShopPhotosError()
    },
    updatePesticideImages: (newImages: Array<Media>) => {
        _delarDto.pesticideLiscence.licence.photos = getMediaObjectFromArray(newImages)
        _delarDtoSubject.next({ ..._delarDto })

        if (newImages.length > 0) {
            _delarDtoError.pesticidePhoto.error = false
            _delarDtoError.pesticidePhoto.msg = ""
        } else {
            _delarDtoError.pesticidePhoto.error = true
            _delarDtoError.pesticidePhoto.msg = "Upload atleast 1 image"
        }

        _delarDtoSubject.next({ ..._delarDto })
        _delarDtoErrorSubject.next({ ..._delarDtoError })
    },
    updateFertiliserImages: (newImages: Array<Media>) => {
        _delarDto.fertilizerLiscence.licence.photos = getMediaObjectFromArray(newImages)
        _delarDtoSubject.next({ ..._delarDto })

        if (newImages.length > 0) {
            _delarDtoError.fertilizerPhoto.error = false
            _delarDtoError.fertilizerPhoto.msg = ""
        } else {
            _delarDtoError.fertilizerPhoto.error = true
            _delarDtoError.fertilizerPhoto.msg = "Upload atleast 1 image"
        }

        _delarDtoSubject.next({ ..._delarDto })
        _delarDtoErrorSubject.next({ ..._delarDtoError })
    },
    updateSeedImages: (newImages: Array<Media>) => {
        _delarDto.seedLiscence.licence.photos = getMediaObjectFromArray(newImages)
        _delarDtoSubject.next({ ..._delarDto })

        if (newImages.length > 0) {
            _delarDtoError.seedPhoto.error = false
            _delarDtoError.seedPhoto.msg = ""
        } else {
            _delarDtoError.seedPhoto.error = true
            _delarDtoError.seedPhoto.msg = "Upload atleast 1 image"
        }

        _delarDtoSubject.next({ ..._delarDto })
        _delarDtoErrorSubject.next({ ..._delarDtoError })
    },
    getDelarDtoObservable: (): Observable<DelarDto | null> => {
        return _delarDtoSubject.asObservable()
    },
    getDelarDtoErrorObservable: (): Observable<DelarDtoError | null> => {
        return _delarDtoErrorSubject.asObservable()
    },
    upadteDelarInfo: (newDelarInfo: Delar) => {
        _delarInfo = newDelarInfo
        _delarInfoSubject.next(_delarInfo)
    },
    reInitDelarDto: (delar: Delar) => {
        _delarDto = {
            name: delar.name,
            intro: delar.intro,
            alternatePhone: delar.alternatePhone,
            shopName: delar.shopName,
            status: delar.status,
            shopAddress: delar.shopAddress,
            shopPhotos: delar.shopPhotos,
            pesticideLiscence: delar.pesticideLiscence,
            fertilizerLiscence: delar.fertilizerLiscence,
            seedLiscence: delar.seedLiscence,
            active: true
        } as DelarDto
        _delarDtoSubject.next({ ..._delarDto })
    },
    getDelarInfo: (): Delar | null => {
        return _delarInfo
    },
    getDelarInfoObservable: (): Observable<Delar | null> => {
        return _delarInfoSubject.asObservable()
    },
    getDelar: (): Delar | null => {
        return _delarDetail.value
    },
    setDelar: (newDelar: Delar) => {
        _delarDetail.next({ ...newDelar })
    },
    getDelarObservable: (): Observable<Delar | null> => {
        return _delarDetail.asObservable()
    },
    checkErrorPersonalDetailPage: () => {
        checkNameError()
        checkAlternatePhoneError()
        checkIntroError()
    },
    checkErrorBussinessDetailPage: () => {
        checkNameError()
        checkAlternatePhoneError()
        checkIntroError()

        checkShopNameError()
        checkShopPhotosError()
        checkShopAddressError()

        checkStateError()
        checkDistrictError()
        checkSubDisctrictError()
        checkVillageError()

        checkPincodeError()
    },
    checkErrorDocumentProoofPage: () => {
        checkNameError()
        checkAlternatePhoneError()
        checkIntroError()
        
        checkShopNameError()
        checkShopPhotosError()
        checkShopAddressError()

        checkStateError()
        checkDistrictError()
        checkSubDisctrictError()
        checkVillageError()

        checkPincodeError()

        // TODO: add other errors also
    }
}